import React, { useState, useEffect } from "react";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import {
  Button,
  Container,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import AuthFooter from "../../components/Footers/AuthFooter";
// import { Link } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { showToast } from "../../helper-methods";
import { fetchServices, userService } from "../../http/http-calls";
import { useHistory } from "react-router-dom";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { hamiltonZipcodeConfig } from "../../config/hamilton-zipcode-config";
import { InputGroup } from "react-bootstrap";

const animatedComponents = makeAnimated();

const VeteranServiceSelection = () => {
  /* eslint-disable */

  const history = useHistory();

  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
    deviceId: "",
    pincodeList: [],
    serviceList: [],
    search: "",
  });
  const [hamiltonPincodeService, setHmiltonPincodeService] = useState([]);
  const [selectedServiceId, setSelectedServiceId] = useState([]);

  const [isDirty, setIsDirty] = useState({
    pincodeList: false,
    // serviceList: false,
  });

  const [errors, setErrors] = useState({});
  const [flag, setFlag] = useState(false);
  // const [searchList, setSearchList] = useState([]);

  const _fetchAllServices = async () => {
    try {
      const res = await fetchServices();
      console.log("allservices", res);
      setServices(res?.data);
    } catch (error) {
      console.log("error", error);
      showToast(
        error.reason && error.reason.length
          ? error.reason
          : "Server error. Try again after sometime.",
        "error"
      );
    }
  };

  // serviceList
  const serviceList = services?.map((each) => {
    // console.log("service",each);
    return {
      id: each?._id,
      label: each?.serviceName,
      value: each?.serviceName,
    };
  });

  const _addVeteranServiceHandler = async () => {
    const newIsDirty = { ...isDirty };
    Object.keys(isDirty).forEach((each) => (newIsDirty[each] = true));
    const error = _validateForm(formData, newIsDirty);
    // console.log("errors => ", error);
    if (!error) {
      setFlag(true);
      // console.log("formData", formData);
      try {
        const res = await userService(formData);
        // console.log("service", res);
        // let defaultProvider = [...res?.defaultProvider, ...res?.providers];
        // let finalArray = res?.defaultProvider
        //   ? defaultProvider
        //   : res?.providers;
        let finalArray = res?.providers;
        history.push({
          pathname: "/service-list",
          state: finalArray,
          selectedServiceId: selectedServiceId,
        });
      } catch (error) {
        console.log("error", error);
        showToast(
          error.reason && error.reason.length
            ? error.reason
            : "Server error. Try again after sometime.",
          "error"
        );
      }
      setFlag(flag);
    }
  };

  const _validateForm = (data, dirties) => {
    const newErrors = { ...errors };

    Object.keys(dirties).forEach((each) => {
      if (each === "pincodeList" && dirties[each]) {
        if (!data?.pincodeList?.length) {
          newErrors.pincodeList = "*Required";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      }
    });
    setIsDirty(dirties);
    setErrors(newErrors);
    return Object.keys(newErrors).length ? true : false;
  };

  const handleCountryListChange = (newValue, actionMeta) => {
    let newFormData = formData;
    const newIsDirty = { ...isDirty };
    newIsDirty.pincodeList = true;
    // console.group("Value Changed >>>");
    // console.log(newValue);
    newFormData.pincodeList = newValue?.map((item) => {
      return item.value;
    });
    setFormData({ ...formData, ...newFormData });
    // console.log(`action: ${actionMeta.action}`);
    // console.groupEnd();
    _validateForm(formData, newIsDirty);
  };

  const handleServiceListChange = (newValue, actionMeta) => {
    // console.log("newValue >>", newValue, actionMeta);

    let newFormData = formData;
    const newIsDirty = { ...isDirty };
    newIsDirty.serviceList = true;

    // if(editDetails && actionMeta === "remove-value"){
    //   console.log(">>>>>>>>>>>>");
    //   let nwewValue = prevData.service.filter(({ id: id1 }) => !newValue.removedValue.some(({ id: id2 }) =>  id2 === id1))
    //   console.log("deleteId", nwewValue);
    // }
    // else{
    newFormData.serviceList = newValue?.map((item) => {
      return item.value;
    });
    // }
    setFormData({ ...formData, ...newFormData });

    setSelectedServiceId(newValue?.map((item) => item.id));
    _validateForm(formData, newIsDirty);

    // console.log(">>>>>.",prevData.service.filter(({ id: id1 }) => !newValue.some(({ id: id2 }) => id2 === id1)));
  };

  const _cancelFormSubmission = () => {
    history.push("/home");
  };

  const handleSelectAllCheckbox = (isChecked) => {
    let newFormData = formData;
    const newIsDirty = { ...isDirty };
    newIsDirty.pincodeList = true;

    const allPincodes = isChecked
      ? hamiltonPincodeService.map((item) => item.value)
      : [];

    setFormData({ ...newFormData, pincodeList: allPincodes });

    _validateForm({ ...newFormData, pincodeList: allPincodes }, newIsDirty);
  };

  useEffect(() => {
    _fetchAllServices();
    let id = window.localStorage.getItem("myDeviceId");
    // console.log("deviceId",id);
    setFormData({ ...formData, deviceId: id });

    getCurrentBrowserFingerPrint().then((fingerprint) => {
      console.log("fingerPrint", fingerprint);
      setFormData({ ...formData, deviceId: fingerprint });
      // fingerprint is your unique browser id.
      // This is well tested

      // the result you receive here is the combination of Canvas fingerprint and audio fingerprint.
    });

    let pincodesStruct = hamiltonZipcodeConfig.map((each) => ({
      label: each?.postalCode,
      value: each?.postalCode,
    }));
    setHmiltonPincodeService(pincodesStruct);
  }, []);

  return (
    <div className="vayco-admin public-protected">
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          <PublicNavbar />
          <div className="content">
            <Container fluid className="mobilePadding-0">
              {/* ==== Page Header ===== */}
              <div className="page_Inner_header">
                <div className="page_title">
                  <h1 className="space_remove">Resource Selection</h1>
                </div>
              </div>

              <div className="card-box">
                <Row style={{ gap: "20px 0" }}>
                  <Col md="4">
                    <FormGroup className="mb-0 mr-2">
                      <div className="d-flex align-items-center justify-content-between gap-2 mt-1 mb-2">
                        <Label className="mb-0">Choose your ZIP Codes</Label>
                        <FormGroup check>
                          <Input
                            type="checkbox"
                            style={{ marginRight: "8px", cursor: "pointer" }}
                            onChange={(e) =>
                              handleSelectAllCheckbox(e.target.checked)
                            }
                            id="chooseZipCode"
                            checked={
                              formData.pincodeList.length ===
                                hamiltonPincodeService.length &&
                              hamiltonPincodeService.length > 0
                            }
                          />
                          <Label check for="chooseZipCode">
                            Select All
                          </Label>
                        </FormGroup>
                      </div>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={hamiltonPincodeService}
                        onChange={handleCountryListChange}
                        value={hamiltonPincodeService.filter((option) =>
                          formData.pincodeList.includes(option.value)
                        )}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select all that apply"
                      />
                      {errors.pincodeList && (
                        <div className="form-error text-danger mt-1">
                          {errors.pincodeList}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup className="mb-0 mr-2">
                      <Label>Service List</Label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        // defaultValue={[serviceList[1]]}
                        isMulti
                        options={serviceList}
                        onChange={handleServiceListChange}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select all that apply"
                        isDisabled={formData.search?.length}
                      />
                      {errors.serviceList ? (
                        <div className="form-error">{errors.serviceList}</div>
                      ) : null}
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup className="mb-0 mr-2">
                      <Label>Search Resource Provider</Label>
                      <InputGroup style={{ maxWidth: "400px" }}>
                        <Input
                          type="text"
                          name="search"
                          placeholder="Search"
                          autoComplete="off"
                          disabled={formData?.serviceList?.length}
                          onChange={(e) =>
                            setFormData({ ...formData, search: e.target.value })
                          }
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <div className="submitWrapper">
                <Button onClick={() => _cancelFormSubmission()}>Cancel</Button>
                <Button
                  color="primary"
                  onClick={() => _addVeteranServiceHandler()}
                  disabled={flag === true}
                >
                  Search
                </Button>
              </div>
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default VeteranServiceSelection;
